module.exports = __webpack_public_path__ + "img/logo.0eb8f21e.png";